import React from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import CopyContent from '../../../../components/common/CopyContent';
import Icon from '../../../../components/Icon/Icon';
import { FormattedMessage } from 'react-intl';

export default ({ id, link, title, handleRemoveFlow, settings }) => {
    return (
        <tr key={id} className="flows-list-item">
            {settings.title && <td scope="row">{title}</td>}
            {settings.link && <td>{link}</td>}
            {settings.controls && <td className='offer-flows-controls'>
                <CopyContent
                    content={link}
                    iconType="copy"
                    copyMessageId="flows.table.click-link"
                    tooltipMessageId="flows.table.referral"
                    tooltipTargetId={`flow_link_${id}`}
                />
                <Link
                    to={`/tools/flows/${id}`}
                    className="flow-control edit-flow"
                    role="button"
                    aria-label="Edit Flow"
                    id={`flow-edit-link-${id}`}
                >
                    <Icon type="edit" />
                </Link>
                <UncontrolledTooltip
                    placement="top"
                    trigger="legacy hover"
                    delay={250}
                    modifiers={{
                        offset: {
                            offset: '0, 5px',
                        },
                    }}
                    target={`flow-edit-link-${id}`}
                >
                    <FormattedMessage id="flows.table.edit" defaultMessage="Edit the stream" />
                </UncontrolledTooltip>
                <a
                    className="flow-control remove-flow"
                    role="button"
                    aria-label="Remove Flow"
                    onClick={() => handleRemoveFlow(id)}
                    id={`flow-delete-link-${id}`}
                >
                    <Icon type="trash" />
                </a>

                <UncontrolledTooltip
                    placement="top"
                    trigger="legacy hover"
                    delay={250}
                    modifiers={{
                        offset: {
                            offset: '0, 5px',
                        },
                    }}
                    target={`flow-delete-link-${id}`}
                >
                    <FormattedMessage id="flows.table.delete" defaultMessage="Delete the stream" />
                </UncontrolledTooltip>
            </td>}

        </tr>
    )
}